// material-ui
import { Typography } from "@mui/material";

// ==============================|| FOOTER - AUTHENTICATION ||============================== //

const AuthFooter = () => (
    <Typography variant="body2" align="center" color="text.secondary">
        &copy; {new Date().getFullYear()} Medallion Traders. All rights reserved.
    </Typography>
);

export default AuthFooter;
